import { useEffect, type ReactNode } from "react";

/**
 * The admin console is dark-only — there is no light mode. This provider
 * exists so we have a single place to mount the `dark` class and to extend
 * with motion / contrast preferences later without touching consumers.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.documentElement.style.colorScheme = "dark";
  }, []);
  return <>{children}</>;
}
